import { contactDetails } from '@utils';
import { FC, ReactNode } from 'react';

type SocialLinkProps = {
  children?: ReactNode;
  className?: string;
};

export const SocialLinks: FC<SocialLinkProps> = ({ className, ...props }) => (
  <div className={className}>
    <ul>
      {contactDetails.facebookPage && (
        <li>
          <a href={contactDetails.facebookPage} title='Facebook'>
            <i className='fab fa-facebook-f'></i>
          </a>
        </li>
      )}
      {contactDetails.twitterPage && (
        <li>
          <a href={contactDetails.twitterPage} title='Twitter'>
            <i className='fab fa-twitter'></i>
          </a>
        </li>
      )}
      {contactDetails.linkedinPage && (
        <li>
          <a href={contactDetails.linkedinPage} title='Linkedin'>
            <i className='fab fa-linkedin'></i>
          </a>
        </li>
      )}
      {contactDetails.instagramPage && (
        <li>
          <a href={contactDetails.instagramPage} title='Instagram'>
            <i className='fab fa-instagram'></i>
          </a>
        </li>
      )}
      {props.children}
    </ul>
  </div>
);
